module.exports = __webpack_public_path__ + "img/1.42241541.png";